/**
 * @requires HBS
 */
(function() {
	/**
	 * @exports DKA.main
	 */
	let module = {};

	/**
	 * Global init code for the whole application
	 */
	module.init = () => {
		module.accordion();
		module.setupMobileNav();
		module.setupDropdowns();
		module.validateFields();
	};

	module.validateFields  = () => {
		document.getElementById("submit").addEventListener("click", checkRequiredFields);
		function checkRequiredFields() { 
			var email = document.forms["cross-reference-form"]["email"].value;
			if (email == "") {
				return false;
			} else if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)){
				document.getElementById("email-error").classList.add('d-none');
				return (true)
			} else {
				document.getElementById("email-error").classList.remove('d-none');
			    return (false);
			}
		}
	};

	module.setupDropdowns  = () =>  {
		
		//event listener for product type change
		document.getElementById("product_type_select").addEventListener("change", handleProductChange);
		document.getElementById("manufacturer_select").addEventListener("change", handleManufacturerChange);

		function handleProductChange(){
  			
  			var productType = document.getElementById("product_type_select");
			
			console.log('the product changed to ' + productType.value);

			// populate the Brand drop down by product type
			// get the data
			fetch('/wp-json/wp/v2/crossreference?per_page=100&orderby=title&order=asc&product_type=' + productType.value)
				.then(response => response.json())
				.then(data => {
					console.log(data);

					var manufacturerSelect = "<option disabled selected value> -- select an option -- </option>";
					var manufacturer = '';
					let manufacturers = [];

					data.forEach(function(item) {

						manufacturer = item.acf.competitor_brand;

						// insert each Manufacturer item an array						
						// check if the value is already in our array
						if (!manufacturers.includes(manufacturer) ){
							manufacturers.push(manufacturer); 
							manufacturerSelect += "<option>" + manufacturer + "</option>"	
						}
					 
					});

					// update DOM with new Manufacturer select contents
					document.getElementById('manufacturer_select').innerHTML = manufacturerSelect;

					// make sure the Part Number drop down is empty and inactive
  					document.getElementById('part_number_select').disabled = true;
					document.getElementById('part_number_select').innerHTML = '<option value=""></option>';

				})
				.catch((error) => {
					console.error('Error:', error);
				});

		}

		function handleManufacturerChange(){
  			var manufacturerType = document.getElementById("manufacturer_select");
  			var productType = document.getElementById("product_type_select");
			
			console.log('the manufacturer changed to ' + manufacturerType.value);
			console.log('the product type is ' + productType.value);

			// populate the Brand drop down by product type
			// get the data
			fetch('/wp-json/wp/v2/crossreference?per_page=100&orderby=title&order=asc&product_type=' + productType.value + '&manufacturer_type=' + manufacturerType.value)
				.then(response => response.json())
				.then(data => {
					console.log(data);

					var partNoSelect = "<option disabled selected value> -- select an option -- </option>";
					var partNo = '';
					let partNos = [];

					data.forEach(function(item) {

						partNo = item.acf.competitor_model_number;

						// insert each partNo item an array						
						// check if the value is already in our array
						if (!partNos.includes(partNo) ){
							partNos.push(partNo); 
							partNoSelect += "<option>" + partNo + "</option>";
						}
					 // 	print_r(partNos);
					});

					// update DOM with new partNo select contents
  					document.getElementById('part_number_select').disabled = false;
					document.getElementById('part_number_select').innerHTML = partNoSelect;

				})
				.catch((error) => {
					console.error('Error:', error);
				});
		}
  
	};

	module.accordion  = () =>  {
		console.log('inside accordion');
		var triggers = document.querySelectorAll('.js-acc-trigger');

		if (!triggers.length) {
			return;
		}

		triggers.forEach(function (trigger) {
			var parentItem = trigger.parentElement;
			trigger.addEventListener('click', function (e) {
				if (parentItem.classList.contains('state-open')) {
					parentItem.classList.remove('state-open');
				} else {
					parentItem.classList.add('state-open');
				}

				e.preventDefault();
			});
		});
	};

	module.setupMobileNav = () => {

		let mobileNavTrigger = document.getElementById('mobileNavTrigger');
		let headerWrapper = document.getElementById('headerWrapper');
		
		if (!mobileNavTrigger) return false;
		mobileNavTrigger.addEventListener('click', (event) => {

			if ( mobileNavTrigger.classList.contains('icon-hamburger') ) {
				mobileNavTrigger.classList.remove('icon-hamburger');
				mobileNavTrigger.classList.add('icon-close');
			} else {
				mobileNavTrigger.classList.remove('icon-close');
				mobileNavTrigger.classList.add('icon-hamburger');
			}

			if ( headerWrapper.classList.contains('header__wrapper--active') ) {
				headerWrapper.classList.remove('header__wrapper--active');
				document.body.classList.remove('state-fixed');
				
			} else {
				headerWrapper.classList.add('header__wrapper--active');
				document.body.classList.add('state-fixed');
				
			}
		});
	};

	var docReady = function docReady(callback) {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
		// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
		// IE <= 8
			document.attachEvent('onreadystatechange', function () {
				if (document.readyState === 'complete') callback();
			});
		}
	};
	docReady(() => {
		module.init();
		//HBS.initPage();
	});

	HBS.namespace('DKA.main', module);
}());